import styled from "styled-components";

export const Container = styled.div`
  min-height: 100vh;
  background: #ececec;

  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 40px 20px 80px;
`;
export const Content = styled.div`
  width: 100%;
  max-width: 900px;
  background: #fff;
  color: #222;

  padding: 60px 70px;

  border: 1px solid #d8d8d8;
  border-radius: 3px;

  box-shadow: 0 10px 35px rgba(0, 0, 0, 0.08);

  font-family: Georgia, "Times New Roman", serif;
  font-size: 17px;
  line-height: 1.85;
  text-align: justify;

  h2 {
    margin-top: 42px;
    margin-bottom: 18px;

    color: #111;
    font-size: 22px;
    font-weight: bold;

    text-transform: uppercase;

    border-bottom: 1px solid #d9d9d9;
    padding-bottom: 8px;
  }

  p {
    margin: 14px 0;
  }

  ul,
  ol {
    margin: 15px 0 15px 28px;
  }

  li {
    margin: 8px 0;
  }

  strong {
    color: #111;
  }

  hr {
    margin: 40px 0;
    border: none;
    border-top: 1px solid #ddd;
  }

  @media (max-width: 768px) {
    padding: 35px 25px;
    font-size: 16px;
  }
`;

export const ContinueButton = styled.button`
  min-width: 340px;
  height: 56px;

  background: #0c2b6e;
  color: white;

  border: none;
  border-radius: 4px;

  font-size: 16px;
  font-weight: 600;

  cursor: pointer;

  transition: 0.2s;

  &:hover {
    background: #092157;
  }
`;

export const SkipButton = styled.button`
  position: fixed;
  bottom: 20px;
  box-shadow: 1px 4px 5px 1px rgba(0, 0, 0, 0.2);
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(241, 241, 241, 0.92);
  color: #0c2b6e;
  padding: 10px 15px;
  border: 1px solid #0c2b6e;
  border-radius: 20px;
  cursor: pointer;
  font-family: "Raleway", sans-serif;
  font-size: 14px;
  z-index: 1000;
  opacity: 0.85;
`;

export const LinksContainer = styled.div`
  display: flex;
  flex-direction: row; /* Alinha os links horizontalmente */
  justify-content: center; /* Alinha os links ao centro */
  width: 100%;

  margin: 15px 0;
  align-items: center; /* Alinha os links verticalmente no centro */
  @media (max-width: 767px) {
    flex-direction: column; /* Coloca os links um abaixo do outro em telas pequenas */
    gap: 15px; /* Ajuste do espaçamento entre os links */
  }
`;

export const LinkLogin = styled.span`
  display: flex;
  align-items: center; /* Garante que o ícone e o texto fiquem alinhados verticalmente */
  justify-content: center;
  cursor: pointer;
  color: #0c2b6e;
  font-family: "Raleway", sans-serif;
  font-weight: 700;
  font-size: 17px;
  text-decoration: underline;
  gap: 5px; /* Adiciona um espaço consistente entre o texto e o ícone */

  margin-top: 0; /* Ajustado para garantir que fiquem alinhados */

  span {
    display: flex;
    align-items: center; /* Alinha o ícone com o texto */
  }

  @media (max-width: 1330px) {
    font-size: 15px;

    gap: 4px; /* Ajuste o gap para dar um pouco de espaçamento entre o texto e o ícone */
  }
`;

export const LogoWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 10px;
`;
export const LogoImage = styled.img`
  width: 130px;
  margin-bottom: 10px;
`;

export const Title = styled.h1`
  max-width: 900px;

  font-family: Georgia, "Times New Roman", serif;
  font-size: 28px;
  font-weight: bold;

  text-transform: uppercase;
  letter-spacing: 1px;

  color: #111;

  text-align: center;

  margin: 0 0 30px;

  line-height: 1.4;
`;
